import React, { useRef, useState } from "react";
import Modal from "../common/Modal";
import Button from "../common/Button";
import { validateDeviceDimensions, isDuplicateDeviceName } from "../../utils/deviceUtils";

function CustomDeviceForm({ existingDevices, onCreate, onClose }) {
  const [name, setName] = useState("");
  const [width, setWidth] = useState("390");
  const [height, setHeight] = useState("844");
  const [error, setError] = useState(null);
  const nameInputRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!name.trim()) {
      setError("Device name is required.");
      return;
    }
    if (isDuplicateDeviceName(name, existingDevices)) {
      setError("A device with this name already exists.");
      return;
    }
    const dims = validateDeviceDimensions(width, height);
    if (!dims.valid) {
      setError(dims.error);
      return;
    }

    try {
      onCreate({ name, width: Number(width), height: Number(height) });
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Modal title="Create custom device" onClose={onClose} initialFocusRef={nameInputRef}>
      <form onSubmit={handleSubmit} className="custom-device-form">
        <label htmlFor="custom-device-name">Device name</label>
        <input
          id="custom-device-name"
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="e.g. My Test Device"
          ref={nameInputRef}
        />

        <div className="dimension-fields">
          <div>
            <label htmlFor="custom-device-width">Width (px)</label>
            <input
              id="custom-device-width"
              type="number"
              min="100"
              max="4000"
              value={width}
              onChange={(event) => setWidth(event.target.value)}
            />
          </div>
          <div>
            <label htmlFor="custom-device-height">Height (px)</label>
            <input
              id="custom-device-height"
              type="number"
              min="100"
              max="4000"
              value={height}
              onChange={(event) => setHeight(event.target.value)}
            />
          </div>
        </div>

        {error && (
          <p className="field-message field-message-error" role="alert">
            {error}
          </p>
        )}

        <div className="form-actions">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create device
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default CustomDeviceForm;
